var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FILE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.35042756 C0,0.604607012 0.60450369,0 1.35034656,0 L12.823307,0 L19.028133,6.22490406 L19.028133,22.6493894 C19.028133,23.395311 18.4232488,24 17.6777828,24 L1.3503502,24 C0.604572376,24 0,23.3954884 0,22.6495724 L0,1.35042756 Z",
    id: "Rectangle-Copy-7",
    fill: "#E4E4E4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0895141,6.38363171 L13.4697357,6.38363171 C13.081971,6.38363171 12.7672634,6.06586871 12.7672634,5.6743393 L12.7672634,0",
    id: "Fill-139-Copy-7",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.207823822
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92838875,14.4859335 L3.92838875,18.4302813 L4.79570332,18.4302813 L4.79570332,16.8006138 L6.44746803,16.8006138 L6.44746803,16.1266496 L4.79570332,16.1266496 L4.79570332,15.2151407 L6.70158568,15.2151407 L6.70158568,14.4859335 L3.92838875,14.4859335 Z M7.20429668,14.4859335 L7.20429668,18.4302813 L8.07161125,18.4302813 L8.07161125,14.4859335 L7.20429668,14.4859335 Z M8.83396419,14.4859335 L8.83396419,18.4302813 L11.623734,18.4302813 L11.623734,17.7010742 L9.70127877,17.7010742 L9.70127877,14.4859335 L8.83396419,14.4859335 Z M12.1098721,14.4859335 L12.1098721,18.4302813 L15.1040409,18.4302813 L15.1040409,17.7010742 L12.9771867,17.7010742 L12.9771867,16.7343223 L14.8885934,16.7343223 L14.8885934,16.0603581 L12.9771867,16.0603581 L12.9771867,15.2151407 L15.0598465,15.2151407 L15.0598465,14.4859335 L12.1098721,14.4859335 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.391ee06023886d7e7189e61beabf20ac.svg";
export { ForwardRef as ReactComponent };